<template>
  <div id="page">

    <!-- breadcrumbs -->
    <section class="container-fluid breadcrumbs d-none d-md-block">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="#">Home</a></li>
                <li class="breadcrumb-item active" aria-current="page">{{ $t('views.login.breadcrumbpage') }}</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
    </section>
    <!-- breadcrumbs END -->

    <main id="main" class="">

      <div class="container px-xs-0 beratung">
        <div class="row">
          <div class="login-heading">
            <i aria-hidden="true" class="icon icon--user-solid"></i>
            <div>
              <h1>{{ $t('views.login.breadcrumbpage') }}</h1>
              <!-- <small class="">{{ $t('views.login.loginnote') }}</small> -->
            </div>
          </div>

        </div>
        <div class="row login-content">

            <h2 class="mb-4" style="margin-bottom: 1rem !important;">{{ $t('views.register.registertext') }}
            </h2>
            <div class="row">
              <div class="col-12 col-lg-4 mb-5 mb-lg-0">
                <div class="mb-4">
                  <label class="form-label" for="username">{{ $t('views.login.username') }}</label>
                  <input type="text" class="form-control" v-model="username" id="username">
                  <div class="d-flex mt-2">
                    <span class="icon icon-alert_info" style="margin-right:5px" aria-hidden="true"></span>
                    <small>{{ $t('views.register.validCharacters') }}</small>
                  </div>
                </div>
                <div class="mb-4">
                  <label class="form-label" for="password">{{ $t('views.login.password') }}</label>
                  <div class="pw-input--wrapper">
                    <input :type="passwordFieldType" class="form-control" v-model="password" id="password"
                      :name="generateRandomName('password')" aria-describedby="passwordHelp"
                      @focus="showPasswordHelp = ''; passwordError = '';"
                      autocomplete="off">
                    <i data-target="password"
                      :class="passwordFieldType === 'password' ? 'onb-visible--on' : 'onb-visible--off'"
                      class="icon pw-input--switch" @click="togglePassword"
                      :title="passwordFieldType === 'password' ? $t('views.login.showpw') : $t('views.login.hidepw')"
                      :aria-label="passwordFieldType === 'password' ? $t('views.login.showpw') : $t('views.login.hidepw')"></i>

                  </div>
                  <div v-if="showPasswordHelp" id="passwordHelp" class="form-text alert alert-danger mt-3">
                    {{ $t('views.register.pwhint') }}
                  </div>

                  <div class="mb-4" style="margin-top:0.8rem">
                    <i aria-hidden="true" class="icon icon--warning me-2"></i>
                    <strong> {{ $t('views.register.pwnoreset') }}</strong>
                  </div>
                  <br>
                  <p>
                    {{ $t('views.register.registernote') }}
                  </p>
                  <p>
                     {{ $t('views.register.nonotifications') }}
                  </p>
                </div>

                <div class="mb-4">
                  <label class="form-label" for="mail">{{ $t('views.register.email') }}</label>
                  <input type="text" class="form-control" v-model="email" id="email" autocomplete="off"
                    :name="generateRandomName('email')" @focus="mailHasFocus = true"  @blur="mailHasFocus = false">
                  <div v-if="email != '' && !mailHasFocus && !isValidEmail(email)" class="form-text alert alert-danger">{{ $t('views.register.emailinvalid') }}</div>
                </div>

                <div class="mb-4">
                  <label class="form-label" for="phone">{{ $t('views.register.phone') }}</label>
                  <input type="text" class="form-control" v-model="phone" id="phone" autocomplete="off"
                    :name="generateRandomName('phone')">
                  <div v-if="phone != '' && !isValidPhone(phone)" class="form-text alert alert-danger">{{ $t('views.register.phoneinvalid') }}</div>
                </div>
                <div class="form-check" style="margin-top: 0.5rem !important">
                  <input class="form-check-input" style="margin-top: 0.4rem !important; margin-left:-1.2rem"
                    type="checkbox" v-model="acceptTerms" id="accept" value="accept">
                  <label for="accept" style="margin-left: 0.3rem;" class="text-black">{{ $t('views.register.acceptance') }} <a :href="getNutzungLink()">{{ $t('views.register.acceptancelink') }}</a> {{ $t('views.register.and') }} <a :href="getDsvgoLink()">{{ $t('views.register.dsgvo') }}</a> {{ $t('views.register.agreeTo') }}</label>
                  <div v-if="error != ''" class="alert alert-danger">{{ error }}</div>
                </div>
                <input id="captchaToken" type="hidden" name="captcha-token" value="">
                <button class="btn btn-primary-custom mb-4" @click="register">{{ $t('views.register.register') }}</button>

                <div v-if="passwordError" class="form-text alert alert-danger">
                  {{ $t('views.register.wrongpw') }}
                </div>

                <div v-if="success != ''" class="form-text alert alert-success">
                  {{ success }}
                </div>

                <h4 class="my-3">{{ $t('views.register.infotext') }}</h4>
                <button class="btn btn-primary-custom" @click="navigateToLogin">{{ $t('views.register.tologin') }}</button>
              </div>
              <div class="col offset-lg-1">
                <h4 class="mb-4" style="margin-top: 0.5rem; margin-bottom: 0.8rem !important;">{{ $t('views.register.help') }}</h4>
                <p>
                  {{ $t('views.register.choosename') }}
                  <br>
                  {{ $t('views.register.nameinfo') }}
                </p>
                <strong>{{ $t('views.register.nosave') }}</strong>
              </div>
            </div>

        </div>

      </div> <!-- /container -->

    </main>


  </div> <!-- #page -->
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import AuthService from '@/services/authService';
import { isValidEmail, isTelephoneString } from '@/utils/validationUtils';
import { sanitizeUrl } from '@braintree/sanitize-url';

export default defineComponent({
  name: 'AccountRegisterView',
  data() {
    const store = useStore();
    const router = useRouter();

    return {
      error: '',
      username: '',
      password: '',
      acceptTerms: false,
      email: '',
      phone: '',
      store,
      router,
      showPasswordHelp: false,
      passwordFieldType: 'password',
      success: '',
      passwordError: '',
      mailHasFocus: false
    };
  },
  mounted() {
    this.loadRecaptcha(function () {
    });
  },
  methods: {
    isValidEmail(mail: string) {
      return isValidEmail(mail);
    },
    isValidPhone(phone: string) {
      return isTelephoneString(phone);
    },
    getNutzungLink() {
      const account = document.getElementById('account');
      if (account) {
        const infoLink = account.getAttribute('data-nutzung-link');
        if (infoLink) {
          return sanitizeUrl(infoLink);
        }
      }
      return "";
    },
    getRecaptchaLink() {
      const account = document.getElementById('account');
      if (account) {
        const infoLink = account.getAttribute('data-recaptcha-key');
        if (infoLink) {
          return sanitizeUrl(infoLink);
        }
      }
      return "";
    },
    getDsvgoLink() {
      const account = document.getElementById('account');
      if (account) {
        const infoLink = account.getAttribute('data-dsgvo-link');
        if (infoLink) {
          return sanitizeUrl(infoLink);
        }
      }
      return "";
    },
    togglePassword() {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
    },
    navigateToLogin() {
      this.router.push('/login');
    },
    generateRandomName(base: string) {
      return base + Math.random().toString(36).substring(2, 15);
    },
    loadRecaptcha(callback: () => void) {
      let win = window as any
      if (win && !win.grecaptcha) {
        let recaptchaScript = document.createElement('script')
        document.head.appendChild(recaptchaScript)
        recaptchaScript.onload = () => {
          // At this point the recaptcha script has loaded but the
          // code in it as not completed loading. Fortunately there's
          // a "ready" function in there that can tell us when it's done.
          let win = window as any
          win.grecaptcha.ready(() => {
            callback()
          })
        }
        recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?render=' + this.getRecaptchaLink());
      } else {
        callback()
      }
    },
    async register() {
      if (!this.checkPassword()) {
        this.passwordError = this.$t('common.checkPassword');
        return;
      }
      this.passwordError = '';
      if (this.acceptTerms) {
        if ((window as any).grecaptcha) {
          const rlreg = this.realRegister;
          const captchaLink = this.getRecaptchaLink;
          (window as any).grecaptcha.ready(function() {
            (window as any).grecaptcha.execute(captchaLink(), {action: "register"}).then(function(token: string) {
              (document.getElementById("captchaToken") as HTMLInputElement).value = token;
              return (document.getElementById("captchaToken") as HTMLInputElement).value;
            }).then((data: string) => {
              if (data) {
                // Submit it
                rlreg();
              }
            });
          });
        } else {
          // Submit it
          // should not happen
          this.realRegister();
        }
      } else {
        this.error = this.$t('common.pleaseAcceptToS');
      }
    },
    async realRegister () {
      try {
        await AuthService.register(this.username, this.email, this.phone, this.password, (document.getElementById("captchaToken") as HTMLInputElement).value);

        this.error = '';
        this.success = this.$t('common.registrationSuccessful');
        setTimeout(() => {
          this.navigateToLogin();
        }, 3000);
      } catch (err: any) {
        if (err && err.message == "client__invalid_phone") {
          this.error = this.$t('common.phoneChangeWarning');
        } else if (err && err.message == "captcha__invalid") {
          this.error = this.$t('common.captchaInvalid');
        } else {
          this.error = this.$t('common.usernameNotAllowed');
        }
      }
    },
    checkPassword() {
      const passwordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=(?:[^0-9]*[0-9]){2}).{10,}$/;

      if (passwordRegex.test(this.password)) {
        this.showPasswordHelp = false;
        return true;
      } else {
        this.showPasswordHelp = true;
        return false;
      }
    }
  }
});
</script>
